import { ReactElement, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { iNominationFormValues } from '@services/NominationService';
import { FileUploadGroupAccessible, TextInput } from '@components';
import { FormType } from '@constants/forms';

function NominationStep8(): ReactElement {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { values, setFieldValue }: { values: iNominationFormValues; setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void } = useFormikContext<iNominationFormValues>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState(false);
  const notMarineOffence = 'The vehicle or number plates were stolen or copied/cloned';
  const marineOffence = 'The vessel was stolen or the identification mark displayed on the vessel was false';
  const filteredData = values.IsMarineOffence ? marineOffence : notMarineOffence;

  return (
    <>
      {!loading && (
        <>
          <div className="vfH2">{filteredData}</div>
          <p>To apply on this ground, you'll need to provide a Victoria Police reference number relating to the incident <b>OR</b> attach a police report.</p>
          <>
            <Field
              name="VictoriaPoliceReferenceNumber"
              component={TextInput}
              title="Victoria Police reference number"
              autocomplete="off"
              isMandatory
            />
            <br />
            <span>Attach any supporting documents (maximum of {values.FileUploadMaxAttachmentsConfig} files; each file should be less than {values.FileUploadSizeConfig}MB)</span>
            <FileUploadGroupAccessible
              uploadAReport="VehicleOrIdentificationStolenOrFalseNameField"
              uploadFieldArrayName="VehicleOrIdentificationStolenOrFalse"
              whoPrepared="VehicleOrIdentificationStolenOrFalseProvider"
              briefDescription="VehicleOrIdentificationStolenOrFalseDescription"
              fileSizeErrorField="VehicleOrIdentificationStolenOrFalseSizeErrorHandle"
              fileUploadFailErrorField="VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle"
              UploadFileSectionError="VehicleOrIdentificationStolenOrFalseFileSectionError"
              fileSizelimit={values.FileUploadSizeConfig.toString()}
              totalFileLimit={values.FileUploadMaxAttachmentsConfig}
              hasPrepared={false}
              hasDescribe={false}
              formType={FormType.NOMINATION} />
          </>
        </>
        )}
    </>
  );
}

export default NominationStep8;
